module.exports = __webpack_public_path__ + "static/img/mumi-1.9a78f14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/mumi-1.jpg
// module id = 04ml
// module chunks = 1